/*
 * Copyright (c) 2025.  Chad and contributors.
 * All rights reserved.
 */

import {onMounted, onUnmounted, ref} from 'vue';
import {isOnline} from '@/utils/network';

export function useNetworkStatus() {
    const online = ref(isOnline());

    const update = () => {
        online.value = isOnline();
    };

    onMounted(() => {
        window.addEventListener('online', update);
        window.addEventListener('offline', update);
    });

    onUnmounted(() => {
        window.removeEventListener('online', update);
        window.removeEventListener('offline', update);
    });

    return {online};
}
